import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { RegisteredNode } from 'data/registeredNode/registeredNode.types';

export enum RegisteredNodeMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newRegisteredNode: RegisteredNode = {
  id: '',
  nodeName: '',
  siteName: '',
  nodeType: '',
  topology: '',
  ipAddr: '',
  ipAddr6: '',
  status: '',
  city: '',
  stateName: '',
  country: '',
  latitude: '',
  longitude: '',
  swVersion: '',
};

export const registeredNodeColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('registeredNode.grid.nodeName'),
    field: 'nodeName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'nodeName',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.siteName'),
    field: 'siteName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'siteName',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.nodeType'),
    field: 'nodeType',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'nodeType',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.topology'),
    field: 'topology',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'topology',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.ipAddr'),
    field: 'ipAddr',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'ipAddr',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.ipAddr6'),
    field: 'ipAddr6',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'ipAddr6',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.status'),
    field: 'status',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'status',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.country'),
    field: 'country',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'country',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.stateName'),
    field: 'stateName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'stateName',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.city'),
    field: 'city',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'city',
    flex: 1,
    minWidth: 198,
  },
  {
    headerName: i18n.t('registeredNode.grid.swVersion'),
    field: 'swVersion',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    tooltipField: 'swVersion',
    flex: 1,
    minWidth: 198,
  },
];
